var _excluded = ["children", "imgContent", "imgSrc", "onClick", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import CardContent from '../CardContent';
import ActionArea from '../ActionArea';
import Media from '../Media';
import Paper from '../Paper';
import { StyledCardMedia } from './StyledCard';
function Card(_ref) {
  var children = _ref.children,
    imgContent = _ref.imgContent,
    imgSrc = _ref.imgSrc,
    onClick = _ref.onClick,
    title = _ref.title,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Paper, _extends({
    elevate: false,
    outlined: true
  }, rest), onClick && /*#__PURE__*/React.createElement(ActionArea, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(StyledCardMedia, null, imgContent, !imgContent && /*#__PURE__*/React.createElement(Media, {
    src: imgSrc,
    title: title
  }))), !onClick && /*#__PURE__*/React.createElement(StyledCardMedia, null, /*#__PURE__*/React.createElement(Media, {
    src: imgSrc,
    title: title
  })), /*#__PURE__*/React.createElement(CardContent, null, children));
}
Card.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The content of the component. React component, node, text etc.
   */
  children: PropTypes.node.isRequired,
  /**
   * Adds the box shadow
   */
  elevate: PropTypes.bool,
  /**
   * Custom image component, element, node etc.
   */
  imgContent: PropTypes.node,
  /**
   * Path to the image
   */
  imgSrc: PropTypes.string,
  /**
   * Function called when node is clicked
   */
  onClick: PropTypes.oneOfType([PropTypes.func, PropTypes.instanceOf(null)]),
  /**
   * Specifies an title & alternate text for an image
   */
  title: PropTypes.string
} : {};
Card.defaultProps = {
  elevate: false,
  imgContent: undefined,
  imgSrc: '',
  title: '',
  onClick: null
};
export default Card;